import React from 'react';
import '../template-file-css/document-file-template.css';


export const KE_IntakeAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='KE_IntakeAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h4>Kingdom Expressions LLC - Comprehensive Client Intake Form</h4></center></p>

                <p className='w-750'><b>Client Information</b></p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Today's Date:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Email Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Referred by:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtReferredBy' name='txtReferredBy' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date of Birth:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Social Security Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSecurityNumber' name='txtSecurityNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Marital Status:</span>
                    <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single <br />
                    <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married <br />
                    <input type='radio' id='rbMaritalStatus_Other' name='rbMaritalStatus' className='add-only' value='Other' /> Other
                </p>
                <p className='w-375'> <input type='text' id='txtMaritalStatusOther' name='txtMaritalStatusOther' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Parent/Guardian (if applicable):</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relation:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtGuardian' name='txtGuardian' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelation' name='txtRelation' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Home Phone:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Work Phone:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Ext:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Cell Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWorkPhone' name='txtWorkPhone' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtExt' name='txtExt' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtStreetAddress' name='txtStreetAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Parish:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZip' name='txtZip' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtParish' name='txtParish' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>School/Work:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Grade/Department:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Teacher/Supervisor:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSchoolWork' name='txtSchoolWork' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtGrade' name='txtGrade' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSupervisor' name='txtSupervisor' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Children/Siblings:</span>
                    <span className='small'>(List names, DOBs, Gender)</span>
                    <textarea id='txtSiblings' name='txtSiblings' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>Medical Information</b></p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Primary Care Physician (PCP):</span> </td>
                        <td className='w-375'> <span className='eleHeader'>PCP Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPcp_Yes' name='rbPcp' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPcp_No' name='rbPcp' className='add-only' value='No' /> No </td>
                        <td className='w-375'> <input type='text' id='txtPcpName' name='txtPcpName' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Current Medications:</span>
                    <input type='radio' id='rbMedications_Yes' name='rbMedications' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedications_No' name='rbMedications' className='add-only' value='No' /> No <br />
                    <span className='small'>(If yes, list medications with dosage and directions)</span>
                </p>
                <p className='w-750'> <input type='text' id='txtListMedications_1' name='txtListMedications_1' className='add-only' /> </p>
                <p className='w-750'> <input type='text' id='txtListMedications_2' name='txtListMedications_2' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'>Previous Hospitalizations/Treatments:</span>
                    <span className='small'>(List hospitals/clinics/physicians, dates, reasons)</span>
                    <textarea id='txtHospitalizations' name='txtHospitalizations' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>Insurance Information</b></p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Person Responsible for Bill:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBill' name='txtBill' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Address (if different):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddress1' name='txtAddress1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Home Phone:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Cell Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHomePhone1' name='txtHomePhone1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCellPhone1' name='txtCellPhone1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Insured Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>SSN:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtInsuredName' name='txtInsuredName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSsn' name='txtSsn' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Group#:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Policy#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDob1' name='txtDob1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtGroup' name='txtGroup' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPolicy' name='txtPolicy' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Client's Relationship to Insured:</span>
                    <input type='radio' id='rbClientRelationship_Self' name='rbClientRelationship' className='add-only' value='Self' /> Self <br />
                    <input type='radio' id='rbClientRelationship_Spouse' name='rbClientRelationship' className='add-only' value='Spouse' /> Spouse <br />
                    <input type='radio' id='rbClientRelationship_Child' name='rbClientRelationship' className='add-only' value='Child' /> Child <br />
                    <input type='radio' id='rbClientRelationship_Other' name='rbClientRelationship' className='add-only' value='Other' /> Other:
                </p>
                <p className='w-375'><input type='text' id='txtClientRelationshipOther' name='txtClientRelationshipOther' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Is this client covered by insurance:</span>
                    <input type='radio' id='rbInsurance_Yes' name='rbInsurance' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInsurance_No' name='rbInsurance' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Provider:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAmerigroup' name='cbAmerigroup' className='add-only' value='Amerigroup' /> Amerigroup </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAetna' name='cbAetna' className='add-only' value='Aetna' /> Aetna </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnitedHealthcare' name='cbUnitedHealthcare' className='add-only' value='United Healthcare' /> United Healthcare
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAmeriHealth' name='cbAmeriHealth' className='add-only' value='AmeriHealth Caritas' /> AmeriHealth Caritas </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLouisiana' name='cbLouisiana' className='add-only' value='Louisiana' /> Louisiana Healthcare Connections </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCigna' name='cbCigna' className='add-only' value='Cigna' /> Cigna
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTricare' name='cbTricare' className='add-only' value='Tricare' /> Tricare </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHumana' name='cbHumana' className='add-only' value='Humana' /> Humana </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBlueCross' name='cbBlueCross' className='add-only' value='BlueCross BlueShield' /> BlueCross BlueShield
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther1' name='cbOther1' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther1' name='txtOther1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>Emergency Contact Information</h4></p>

                <p className='w-750'><b>Emergency Contact 1:</b></p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFirstName1' name='txtFirstName1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastName1' name='txtLastName1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Home Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtHomePhone2' name='txtHomePhone2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Work Phone:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Cell Phone</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtWorkPhone1' name='txtWorkPhone1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCellPhone2' name='txtCellPhone2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>Emergency Contact 2:</b></p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFirstName2' name='txtFirstName2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastName2' name='txtLastName2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Home Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRelationship1' name='txtRelationship1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtHomePhone3' name='txtHomePhone3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Work Phone:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Cell Phone</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtWorkPhone2' name='txtWorkPhone2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCellPhone3' name='txtCellPhone3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>Consent Forms and Acknowledgements</b></p>

                <p className='w-750'><span className='eleHeader'>General Consent for Treatment:</span>
                    <input type='checkbox' id='cbTreatment' name='cbTreatment' className='add-only' value='Specified Provider' /> I consent to treatment by specified provider and understand I can discontinue treatment at any time.
                </p>

                <p className='w-750'><span className='eleHeader'>Mental Health Rehabilitation Permission for Evaluation:</span>
                    <input type='checkbox' id='cbRehabilitation' name='cbRehabilitation' className='add-only' value='Psychiatric' /> I give permission for psychiatric, psychological, educational, and psychosocial evaluations.
                </p>

                <p className='w-750'><span className='eleHeader'>Emergency Care Consent:</span>
                    <input type='checkbox' id='cbEmergencyCare' name='cbEmergencyCare' className='add-only' value='Authorize' /> I authorize Kingdom Expressions LLC to obtain emergency medical care if necessary.
                </p>

                <p className='w-750'><span className='eleHeader'>Telehealth Consent:</span>
                    <input type='checkbox' id='cbTelehealth' name='cbTelehealth' className='add-only' value='Telemedicine System' /> I agree to participate in and receive behavioral health services through the telemedicine
                    system.
                </p>

                <p className='w-750'><span className='eleHeader'>HIPAA Privacy Acknowledgement:</span>
                    <input type='checkbox' id='cbHipaaPrivacy' name='cbHipaaPrivacy' className='add-only' value='HIPAA' /> I have received and understand the HIPAA form.
                </p>

                <p className='w-750'><span className='eleHeader'>Release of Information:</span>
                    <input type='checkbox' id='cbReleaseInformation' name='cbReleaseInformation' className='add-only' value='Medical Information' /> I authorize the release of medical information for insurance reimbursement and program compliance.
                </p>

                <p className='w-750'><span className='eleHeader'>Rights and Responsibilities Acknowledgement:</span>
                    <input type='checkbox' id='cbResponsibilities' name='cbResponsibilities' className='add-only' value='Responsibilities' /> I have received and understand my rights and responsibilities.
                </p>

                <p className='w-750'><span className='eleHeader'>Complaint or Grievance Policy Acknowledgement:</span>
                    <input type='checkbox' id='cbGrievancePolicy' name='cbGrievancePolicy' className='add-only' value='Procedure' /> I have received and understand Kingdom Expressions' Complaint or Grievance Policy/Procedure.
                </p>

                <p className='w-750'><span className='eleHeader'>Freedom of Choice:</span>
                    <input type='checkbox' id='cbFreedom' name='cbFreedom' className='add-only' value='Expressions' /> I freely choose to receive services from Kingdom Expressions and will notify previous providers.
                </p>

                <p className='w-750'><span className='eleHeader'>Client Handbook Acknowledgement:</span>
                    <input type='checkbox' id='cbClientHandbook' name='cbClientHandbook' className='add-only' value='Orientation' /> I have received the Kingdom Expressions Client Orientation and Handbook.
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Client Signature: </td>
                        <td className='small w-250'> Print Name: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Guardian (if applicable): </td>
                        <td className='small w-250'> Print Name: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Witness(KE Staff): </td>
                        <td className='small w-250'> Print Name: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}